import React from 'react';
import { palette, typography } from '@citrite/web-ui-component';
import styled from '@emotion/styled';

const Title = styled.h2`
	color: ${palette.grey900};
	font-size: ${typography.sizes.xl};
	font-weight: ${typography.weights.semiBold};
	margin: 0;
`;

const Description = styled.span`
	color: ${palette.grey800};
	font-size: ${typography.sizes.sml};
	font-weight: ${typography.weights.regular};
`;

interface HeaderProps {
	title: string;
	description?: string;
}

export const OfflineHeader: React.FC<HeaderProps> = ({ title, description }) => {
	return (
		<div>
			<Title>{title}</Title>
			{description && <Description>{description}</Description>}
		</div>
	);
};
